export const isValidUrl = (url) => {
    try {
        const hostname = verifyHostname(url);
        return hostname != null;
    } catch (e) {
        return false;
    }
};

export const extractDomain = (url) => {
    try {
        return verifyHostname(url);
    } catch (e) {
        return null; 
    }
};

const verifyHostname = (url) => {
    const hostname = new URL(url).hostname;
    const parsedUrlHostnameParts = hostname.split('.');
    // reject URLs without a TLD, e.g. http://www.cnn
    if (parsedUrlHostnameParts.length == 2 && parsedUrlHostnameParts[0] == "www") {
       return null
    }
    // reject URLs with an empty TLD, e.g. http://www.cnn.
    if (parsedUrlHostnameParts.length == 3 && parsedUrlHostnameParts[2].length == 0) {
        return null
     }
    return hostname
}